import React, { useState, useEffect } from 'react'
import TableForm from 'live/components/forms/ui/TableForm'
import { Modal, Button } from 'react-bootstrap'
import SubmitOrCancel from 'live/components/forms/ui/submit-or-cancel'

export interface BtnFilter {
    name: string
    key: string
    color?: string
    activeColor?: string
}

const tableColumns: any[] = [
    {
        label: 'Name',
        name: 'name',
        type: 'text'
    },
    {
        label: 'Key',
        name: 'key',
        type: 'text'
    },
    {
        label: 'Color',
        name: 'color',
        type: 'color'
    },
    {
        label: 'Active Color',
        name: 'activeColor',
        type: 'color'
    }
]

const ModalConfigInclusiveFilters = ({ btnFiltersOR, show, hide, onChange }: any): JSX.Element => {
    const [data, setData] = useState<any[]>(btnFiltersOR)
    const [msgError, setMsgError] = useState<any[]>([])

    useEffect(() => {
        setMsgError([])
        setData(btnFiltersOR)
    }, [show])

    const saveFilters = (filters: BtnFilter[]) => {
        fillEmptyColors(filters)
        const messagesError = mountMsgError(filters)
        setMsgError(messagesError)

        if (messagesError.length === 0) {
            onChange(filters)
            hide()
        }
    }

    const mountMsgError = (filters: BtnFilter[]) => {
        const filtersSet = new Set()
        const messages: string[] = []

        filters.forEach(({ key }) => filtersSet.add(key))

        if (filters.some(({ key }) => key === '')) {
            messages.push('Não é permitido filtro com key vazia')
        }

        if (filtersSet.size !== filters.length) {
            messages.push('Não é permitido ter mais de um filtro com a mesma key')
        }

        return messages
    }

    const fillEmptyColors = (filters: BtnFilter[]) => {
        if (!filters || filters.length === 0) return

        filters.forEach(filter => {
            if (filter.color === '') filter.color = '#030303'
            if (filter.activeColor === '') filter.activeColor = '#030303'
        })
    }

    return (
        <Modal show={show} onHide={hide}>
            <Modal.Header closeButton>
                <Modal.Title>Configuration Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <TableForm fields={tableColumns} data={data} onChange={setData} />

                    {msgError.map((msg, index) => {
                        return (
                            <div key={index}>
                                <small style={{ marginTop: 5, color: '#D9534F' }}>{msg}</small>
                            </div>
                        )
                    })}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <SubmitOrCancel buttonMessage={'Ok'} onSubmit={() => saveFilters(data)} onCancel={hide} />
            </Modal.Footer>
        </Modal>
    )
}

export default ModalConfigInclusiveFilters
